module.exports = __webpack_public_path__ + "static/media/T & C.83357909.jpg";